import ExamChoice, { CustomRadio } from './ExamChoice';

export { CustomRadio };
export default ExamChoice;
